var o;(function(v){v[v.Draft=1]="Draft",v[v.Active=2]="Active",v[v.Archived=3]="Archived"})(o||(o={}));var d;(function(v){v[v.Custom=1]="Custom",v[v.Credly=2]="Credly"})(d||(d={}));export{o as CertificateTemplateState,d as CertificateTemplateType};
//# sourceMappingURL=certificate-template.js.map
